import React from 'react';
import {
  Box,
  Tabs as MuiTabs,
  SxProps,
  Tab,
  TabProps,
  Typography
} from '@mui/material';

export type TabItem = {
  value: string;
  label: string | React.ReactNode;
  count?: number | string;
} & Omit<TabProps, 'value' | 'label'>;

type Props = {
  tabs: TabItem[];
  value: string;
  onChange: (newValue: any) => void;
  variant?: 'square-button' | 'files';
};

const tabsContainerStyle: SxProps = {
  height: 55,
  display: 'flex',
  alignItems: 'center',
  color: 'customGrey.dark'
};

const Tabs: React.FC<Props> = ({
  tabs,
  value,
  onChange,
  variant = 'square-button'
}) => {
  const leftValueIndex = tabs.findIndex((tab) => tab.value === value) - 1;
  const rightValueIndex = tabs.findIndex((tab) => tab.value === value) + 1;

  return (
    <MuiTabs
      value={value}
      onChange={(e, newValue) => onChange(newValue)}
      aria-label="secondary tabs"
      TabIndicatorProps={{
        hidden: true
      }}
      sx={tabsContainerStyle}
    >
      {tabs.map((tabItem, index) => {
        const extraStyle =
          variant === 'files'
            ? {
                ...(index === leftValueIndex && { borderRight: 'none' }),
                ...(index === rightValueIndex && { borderLeft: 'none' })
              }
            : {};

        return (
          <Tab
            key={tabItem.value}
            {...tabItem}
            sx={{
              ...extraStyle
            }}
            icon={
              Number.isInteger(tabItem.count) ||
              typeof tabItem.count === 'string' ? (
                <Box
                  sx={{
                    backgroundColor: 'customGrey.light',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'customGrey.dark',
                    px: '8px',
                    py: '6px'
                  }}
                >
                  <Typography
                    sx={{
                      size: '14px',
                      lineHeight: '20px',
                      fontWeight: 500,
                      color: 'customGrey.dark'
                    }}
                  >
                    {tabItem.count}
                  </Typography>
                </Box>
              ) : undefined
            }
            iconPosition="end"
          />
        );
      })}
      {variant === 'files' && (
        <Box
          sx={{
            flexGrow: 1,
            borderBottom: '2px solid',
            borderColor: 'customGrey.dark'
          }}
        />
      )}
    </MuiTabs>
  );
};

export { Tabs };
